import { render, staticRenderFns } from "./Rulelist.vue?vue&type=template&id=63d14347&scoped=true&"
import script from "./Rulelist.vue?vue&type=script&lang=js&"
export * from "./Rulelist.vue?vue&type=script&lang=js&"
import style0 from "./Rulelist.vue?vue&type=style&index=0&id=63d14347&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d14347",
  null
  
)

export default component.exports